import {PropsWithChildren} from "react";
import {CreateBundleProvider} from ".";

export function CreateBundleContextWrapper({children}: PropsWithChildren) {
  return <CreateBundleProvider>{children}</CreateBundleProvider>;
}
